

export const ServiceData = [
    {
        icon: "web-application.jpeg",
        title: "Web Application",
        img: "service-1.jpg",
        description: "Web design refers to the process of creating websites that are visually appealing and user-friendly. It encompasses several different aspects, including graphic design, interface design, "
    },
    {
        icon: "web.png",
        title: "Web Design",
        img: "service-1.jpg",
        description: "Web design refers to the process of creating websites that are visually appealing and user-friendly. It encompasses several different aspects, including graphic design, interface design, "
    },
    {
        icon: "app.png",
        img: "service-1.jpg",
        title: "App Design",
        description: "Web design refers to the process of creating websites that are visually appealing and user-friendly. It encompasses several different aspects, including graphic design, interface design, "
    },
    {
        icon: "seo.png",
        img: "service-1.jpg",
        title: "SEO",
        description: "Web design refers to the process of creating websites that are visually appealing and user-friendly. It encompasses several different aspects, including graphic design, interface design, "
    },
    {
        icon: "web-hosting.png",
        img: "service-1.jpg",
        title: "Web Hosting",
        description: "Web design refers to the process of creating websites that are visually appealing and user-friendly. It encompasses several different aspects, including graphic design, interface design, "
    },
]